package one.healthium.login.navigation.silent_login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.login.ui.silent_login.SilentLoginScreen

@Composable
fun SilentLoginContent(component: SilentLoginComponent, standalone: Boolean = true) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        SilentLoginScreen(component.token, standalone, component)
    }
}